import axiosInstance from "./AxiosInstance";

// export function createAssetApi(data){
//     return axiosInstance.post('api/asset',data)
// }
// export function getAssetOverviewApi(assetId){
//     return axiosInstance.get(`api/asset/overview/${assetId}`)
// }
// export function getAssetUnitListApi(assetId,param){
//     const fparam=new URLSearchParams(param).toString()
//     return axiosInstance.get(`api/asset/units/${assetId}?${fparam}`)
// }
// export function getAssetMaintenanceListApi(assetId,param){
//     const fparam=new URLSearchParams(param).toString()
//     return axiosInstance.get(`api/asset/maintenance/${assetId}?${fparam}`)
// }
// export function getAssetInsuranceListApi(assetId,param){
//     const fparam=new URLSearchParams(param).toString()
//     return axiosInstance.get(`api/asset/insurance/${assetId}?${fparam}`)
// }
// export function getAssetDisposalListApi(assetId,param){
//     const fparam=new URLSearchParams(param).toString()
//     return axiosInstance.get(`api/asset/disposal_info/${assetId}?${fparam}`)
// }

export function getUserAllocatedAssets(userId, params = {}) {
  return axiosInstance.get(`api/asset-user-allocated/${userId}`, { params });
}

// Export User Allocated Assets to Excel (with optional search)
export function exportUserAllocatedAssets(userId, searchTerm = '') {
  return axiosInstance.get(`api/asset-user-allocated/${userId}`, {
    params: { export: true, search: searchTerm },
    responseType: 'blob',  // Important for Excel file
  });
}
export function getUserAllAssetLogs(userId,params = {}) {
  return axiosInstance.get(`api/user-asset-logs/${userId}`, { params });
}
export function exportUserAssetLogs(userId, searchTerm = '') {
  return axiosInstance.get(`api/user-asset-logs/${userId}?export=true`, {
    params: { search: searchTerm },
    responseType: 'blob'
  });
}


//asset
export function AllAssetApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/asset?${fparam}`);
}
export function AssetDetailsApi(assetId) {
  return axiosInstance.get(`api/asset_detail/${assetId}`);
}
export function AssetMoveRequestApi(id, data) {
  return axiosInstance.post(`api/asset-move-request/${id}`, data);
}
export function AssetMoveRequestActionApi(id, data) {
  return axiosInstance.post(`api/asset-move-accept/${id}`, data);
}
export function AssetSearchAllocationOptionApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/search/allocation_to?${fparam}`);
}
export function AssetAllocateApi(unitId, data) {
  return axiosInstance.put(`api/asset/allocate/${unitId}`, data);
}
export function AssetMovementHistoryApi(unitId, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/asset-movement-history/${unitId}?${fparam}`);
}
export function getAssetMovementHistoryExport(unitId,param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/asset-movement-history/${unitId}?${fparam}`, {
    responseType: "blob",
  });
}
export function AssetDisposeApi(id, data) {
  return axiosInstance.post(`api/asset-dispose/${id}`, data);
}
export function AsseMaintenanceApi(id, data) {
  return axiosInstance.post(`api/asset-maintenance-add/${id}`, data);
}
export function AsseMaintenanceCompleteApi(id, data) {
  return axiosInstance.post(`api/asset-maintenance-completion/${id}`, data);
}
export function AssetReturnApi(id, data) {
  return axiosInstance.post(`api/asset-return-request/${id}`, data);
}
export function AssetReturnCancelApi(id, data) {
  return axiosInstance.post(`api/cancel-return-request/${id}`, data);
}
export function AssetReturnRequestList(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/return-requested-assets?${fparam}`);
}
export function AssetReturnActionApi(id, data) {
  return axiosInstance.post(`api/asset-return-accept/${id}`, data);
}
export function AssetEditRFIDApi(id, data) {
  return axiosInstance.put(`api/add-asset-rfid/${id}`, data);
}
export function AssetForceReturnApi(id, data) {
  return axiosInstance.post(`api/asset-force-return/${id}`, data);
}
export function AssetMoveRequestListApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/assets-move-request?${fparam}`);
}
export function AssetMoveRequestCancelApi(id, data) {
  return axiosInstance.post(`api/cancel-move-request/${id}`, data);
}
export function AssetEditApi(id, data) {
  return axiosInstance.put(`api/asset_detail/${id}`, data);
}
export function AssetEditImageApi(id, data) {
  return axiosInstance.patch(`api/asset_detail/${id}`, data);
}
//my-asset
export function getMyAssetList(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/my-assets?${fparam}`);
}
export function getDepartmentAssetList(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/allocated-to-department-assets?${fparam}`);
}
export function getDepartmentEmployeeAssetList(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/allocated-to-employee-assets?${fparam}`);
}
export function getDepartmentEmployeeAssetDetails(empId,param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/allocated-to-employee-assets/${empId}?${fparam}`);
}
export function getDepartmentAssetListExport(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/allocated-to-department-assets?${fparam}`, {
    responseType: "blob",
  });
}
export function getDepartmentEmployeeAssetListExport(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/allocated-to-employee-assets?${fparam}`, {
    responseType: "blob",
  });
}
export function AssetTransferRequest(id, data){
  return axiosInstance.post(`api/e2e-asset-move-request/${id}`, data)
}
export function getAssetTransferRequest(params){
  const param = new URLSearchParams(params).toString();
  return axiosInstance.get(`api/e2e-asset-move-request?${param}`)
}

export function employeeAssetTrasferActionApi(id,data){
  return axiosInstance.post(`api/e2e-accpet-move-requests/${id}`,data)
}

export function storeManagerGetAssetTransferRequestApi(param){
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(`api/store/e2e-move-requests?${fparam}`)
}

export function storeManagerAssetTransferActionApi(id,data){
  return axiosInstance.post(`api/store/e2e-approve-move-requests/${id}`,data)
}